import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Pricing from "@/pages/Pricing";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import NewRepurpose from "@/pages/NewRepurpose";
import History from "@/pages/History";
import BillingSuccess from "@/pages/BillingSuccess";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Result from "@/pages/Result";

function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-black">
                <div className="font-mono-ui text-xs tracking-widest text-zinc-500 uppercase">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function App() {
    return (
        <div className="App dark">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/auth/callback" element={<AuthCallback />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/verify-email" element={<VerifyEmail />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/app" element={<Protected><AppLayout /></Protected>}>
                            <Route index element={<Navigate to="/app/dashboard" replace />} />
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="new" element={<NewRepurpose />} />
                            <Route path="history" element={<History />} />
                            <Route path="result/:id" element={<Result />} />
                            <Route path="billing/success" element={<BillingSuccess />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
                <Toaster theme="dark" position="top-right" />
            </AuthProvider>
        </div>
    );
}

export default App;
